export const SEO_ENDPOINTS = {
  getSeoMetaHtml: "/api/SEO/GetSeoMetaHtml",
  getDataLayerHtml: "/api/SEO/GetDataLayerHtml",
  getSitemapXml: "/api/SEO/GetSitemapXML",
};
